module.exports = __webpack_public_path__ + "static/media/Whisperflo.05a53793.jpg";